import React from "react";

import { Notifications } from "./Notifications";

export const NotificationsSettings: React.FC = () => (
    <div className="settings__notifications">
        <header className="settings__header">
            <h3>Notifications</h3>
        </header>

        <Notifications />
    </div>
);
